import { Component, ViewChild, ElementRef } from '@angular/core';
import { AbstractControl, FormBuilder, FormGroup, ValidationErrors, Validators } from '@angular/forms';
import { MatDialog } from '@angular/material/dialog';
import { SuccessModalWithoutCheckComponent } from '../success-modal-without-check/success-modal-without-check.component';
import { SuccessModalWithCheckComponent } from '../success-modal-with-check/success-modal-with-check.component';
import { DomSanitizer } from "@angular/platform-browser";
import swal from 'sweetalert2';
import { ComplaintsService } from '../../service/complaints.service'
import { session } from '../../../../environments/environment.session'
import { SpinnerService } from '../../../shared/spinner.service'
import { AreaMapService } from '../../service/area-map.service'
import { FileUploadService } from '../../service/file-upload.service'
import { DepartmentService } from '../../service/department.service'
import { Location } from '@angular/common';
import Swal from 'sweetalert2';
import { EscalationService } from '../../service/escalation.service'
@Component({
  selector: 'app-new-complaint',
  templateUrl: './new-complaint.component.html',
  styleUrls: ['./new-complaint.component.css']
})
export class NewComplaintComponent {
  complaint_form: FormGroup;
  formSubmitted: boolean = false
  intant_resolve_form: FormGroup | any;
  uploaded_fileName: string = '';
  is_instant_resolved: boolean = false;
  zones = ['zone1', 'zone2', 'zone3', 'zone4', 'zone5']
  wards = ['ward1', 'ward2', 'ward3', 'ward4', 'ward5']
  mohallas = ['mohalla1', 'mohalla2', 'mohalla3', 'mohalla4', 'mohalla5']
  selectedZone: any;
  showHiddenFields() {
    this.is_instant_resolved = !this.is_instant_resolved;
  }
  @ViewChild('comDocInput') comDocInput!: ElementRef;
  @ViewChild('othersDocInput') othersDocInput!: ElementRef;
  @ViewChild('resolvedDocInput') resolvedDocInput!: ElementRef;
  // @ViewChildren('formField') formFields: QueryList<ElementRef> | undefined;
  constructor(public location: Location, private es: EscalationService, private deptS: DepartmentService, private sanitizer: DomSanitizer, private fus: FileUploadService, private areaMapService: AreaMapService, private tspinner: SpinnerService, private dialog: MatDialog, private fb: FormBuilder, private cs: ComplaintsService
  ) {
    this.complaint_form = this.fb.group({
      full_name: ['', [
        Validators.required,
        Validators.pattern(/^(?!\s)[A-Za-z\s'-]+$/)
      ]],
      mobile_no: ['', [Validators.required, this.indianMobileValidator]],
      is_instant_resolved: [false],
      zone: [undefined],
      zone_cd: [undefined],
      zone_leaf_cd: [undefined, Validators.required],
      ward: [undefined],
      ward_cd: [undefined ],
      ward_leaf_cd: [undefined, Validators.required],
      mohalla: [undefined],
      mohalla_cd: [undefined],
      mohalla_leaf_cd: [undefined, Validators.required],
      resolver_user_id: [undefined, Validators.required],
      complaint_desc: [
        '',
        [
          Validators.required,
          Validators.maxLength(500),
          this.noStartWithWhitespaceValidator
        ]
      ],
      uploads_image: [''],
      others_doc: [''],
      uploaded_fileName: [''],

    }, {
      // validators: this.atLeastOneCheckboxCheckedValidator
    });

    this.intant_resolve_form = this.fb.group({
      resolved_remark: ['', [Validators.required, Validators.maxLength(500),
      this.noStartWithWhitespaceValidator]
      ],
      approval_desc: ['', [Validators.required, Validators.maxLength(500),
      this.noStartWithWhitespaceValidator]],
      approval_doc: [''],
      is_instant_resolved: [false],
    })
  }
  erpUser: any
  allArea: any = []
  allAreaObj: any = {}
  zoneArr: any = []
  wordArr: any = []
  zoneWordMohallaObj: any = {}
  wordCodeObj: any = {}
  mohallaCodeObj: any = {}
  async ngOnInit() {
    this.erpUser = JSON.parse(atob(session.erpUser));
    this.tspinner.show('', '')
    await this.getArea()
    await this.getDepartments()
    await this.getEscalationRules();
    this.tspinner.hide()

  }

  allEscalationRule: any = []
  async getEscalationRules() {
    let obj = { b_acct_id: this.erpUser.b_acct_id }
    let resp = await this.es.getEscalationRules(JSON.stringify(obj))
    if (resp['error'] == false) {
      this.allEscalationRule = resp['data']
    } else {
      this.tspinner.hide()
      Swal.fire('Opps !!', resp['data'], 'error')
    }




  }

  allDepartment: any = []
  allDepartmentCd: any = []
  async getDepartments() {
    let obj = { b_acct_id: this.erpUser.b_acct_id }
    let resp = await this.deptS.getDepartment(JSON.stringify(obj))
    if (resp['error'] == false) {
      this.allDepartment = resp['data']
      this.allDepartment.forEach((x: any) => {
        const depCd = x['dep_cd'];
        this.complaint_form.addControl(depCd, this.fb.control(false));
        let obj: any = {}
        obj[depCd] = x['department_name']
        this.allDepartmentCd.push(obj);
      });
    } else {
      this.tspinner.hide()
      Swal.fire('Opps !!', resp['data'], 'error')
    }
  }

  zoneLeafCode: any = {}
  async getArea() {
    let resp = await this.areaMapService.getAreaMapData({ b_acct_id: this.erpUser.b_acct_id, filter_value: 'zone' })
    // let resp = await this.areaMapService.getAreaMapData({ b_acct_id: this.erpUser.b_acct_id })
    if (resp['error'] == false) {
      try {
        // let temp: any = []
        // this.zoneArr = []
        this.zoneArr = resp['zone']
        resp['zone'].map((x: any) => {
          this.zoneWordMohallaObj[x['zone_leaf_cd']] = x
        })
        this.wordArr = []
        this.mohallaArr = []
        //  this.wordArr = resp['zone']
        // this.allArea.map((x: any) => {
        //   if (!temp.includes(x['zone_cd'])) {
        //     this.zoneArr.push(x);
        //     this.zoneLeafCode[x['zone_cd']] = x
        //     temp.push(x['zone_cd'])
        //   }
        //   // this.wordCodeObj[x['word'].trim()] = x
        //   // this.allAreaObj[x['id']] = x

        //   // if (this.zoneWordMohallaObj[x['zone_cd']]) {
        //   //   if (this.zoneWordMohallaObj[x['zone_cd']][x['word'].trim()]) {
        //   //     this.zoneWordMohallaObj[x['zone_cd']][x['word'].trim()].push(x)
        //   //   } else {
        //   //     this.zoneWordMohallaObj[x['zone_cd']][x['word'].trim()] = []
        //   //     this.zoneWordMohallaObj[x['zone_cd']][x['word'].trim()].push(x)
        //   //   }
        //   // } else {
        //   //   this.zoneWordMohallaObj[x['zone_cd']] = {}
        //   //   this.zoneWordMohallaObj[x['zone_cd']][x['word'].trim()] = []
        //   //   this.zoneWordMohallaObj[x['zone_cd']][x['word'].trim()].push(x)
        //   // }
        // })


      } catch (err) {
        this.tspinner.hide()
      }
    } else {
      swal.fire('Error', resp['data'], 'error')
      this.tspinner.hide()
    }
  }



  async changeZone(leaf_cd: any) {
    this.node_cd=[]
    await this.getword(leaf_cd)
    this.complaint_form.patchValue({
      zone: this.zoneWordMohallaObj[leaf_cd]['zone'],
      zone_cd: this.zoneWordMohallaObj[leaf_cd]['zone_cd']
    })
    await this.getResolver()
  }


  async getword(leaf_cd: any) {
    this.tspinner.show('', '')
    this.node_cd.push(leaf_cd)
    let resp: any = await this.areaMapService.getAreaMapData({ b_acct_id: this.erpUser.b_acct_id, filter_value: 'ward', leaf_cd: leaf_cd });
    if (resp['error'] == false) {
      this.tspinner.hide()
      this.wordArr = resp['ward'];
      resp['ward'].map((x: any) => {
        this.wordCodeObj[x['ward_leaf_cd']] = x
      })


      if (this.wordArr.length == 1) {
        this.complaint_form.patchValue({
          ward: this.wordArr[0]['ward'],
          ward_cd: this.wordArr[0]['ward_cd'],
          ward_leaf_cd: this.wordArr[0]['ward_leaf_cd'],
          mohalla: undefined,
          mohalla_cd: undefined,
          mohalla_leaf_cd: undefined
        })
        await this.getMohalla(this.wordArr[0]['ward_leaf_cd'])
      } else {
        this.complaint_form.patchValue({
          ward: undefined,
          ward_cd: undefined,
          ward_leaf_cd: undefined,
          mohalla: undefined,
          mohalla_cd: undefined,
          mohalla_leaf_cd: undefined
        });
      }

    } else {
      this.tspinner.hide()
      this.wordArr = []
      swal.fire('Error', 'Ward is not map', 'error');
    }
  }


  async getMohalla(leaf_cd: any) {
    this.tspinner.show('', '')
     this.node_cd.push(leaf_cd)
    let resp: any = await this.areaMapService.getAreaMapData({ b_acct_id: this.erpUser.b_acct_id, filter_value: 'mohalla', leaf_cd: leaf_cd });
    if (resp['error'] == false) {
      this.tspinner.hide()
      this.mohallaArr = resp['mohalla'];
      resp['mohalla'].map((x: any) => {
        this.mohallaCodeObj[x['mohalla_leaf_cd']] = x
      })

      if (this.mohallaArr.length == 1) {
        this.complaint_form.patchValue({
          mohalla: this.mohallaArr[0]['mohalla'],
          mohalla_cd: this.mohallaArr[0]['mohalla_cd'],
          mohalla_leaf_cd: this.mohallaArr[0]['mohalla_leaf_cd']
        });
      } else {
        this.complaint_form.patchValue({
          mohalla: undefined,
          mohalla_cd: undefined,
          mohalla_leaf_cd: undefined
        });
      }

    } else {
      this.tspinner.hide()
      swal.fire('Error', 'Mohalla is not map', 'error');
    }

  }




  mohallaArr: any = [];
  async wordChange(leaf_cd: any) {
    this.complaint_form.patchValue({
      ward: this.wordCodeObj[leaf_cd]['ward'],
      ward_cd: this.wordCodeObj[leaf_cd]['ward_cd'],
      mohalla: undefined,
      mohalla_cd: undefined,
      mohalla_leaf_cd: undefined
    })

    await this.getMohalla(leaf_cd)
    await this.getResolver()
    // console.log(this.wordCodeObj, this.zoneWordMohallaObj)

    // let zone = this.zoneLeafCode[this.complaint_form.value.zone_cd]['zone'];
    // let leaf_cd = this.zoneLeafCode[this.complaint_form.value.zone_cd]['leaf_cd'];

    // this.mohallaArr = []
    // this.mohallaArr = this.zoneWordMohallaObj[this.complaint_form.value.zone_cd][this.complaint_form.value.ward]
    // this.complaint_form.patchValue({
    //   zone: zone,
    //   leaf_cd: leaf_cd
    // });

  }


  async changeMohalla(leaf_cd: any) {
    
    this.complaint_form.patchValue({
      mohalla: this.mohallaCodeObj[leaf_cd]['mohalla'],
      mohalla_cd: this.mohallaCodeObj[leaf_cd]['mohalla_cd']
    })
    await this.getResolver()
  }

  ////Name validation
  allowOnlyKeysForName(event: KeyboardEvent): void {
    const allowedKeys = ['Backspace', ' ', 'ArrowLeft', 'ArrowRight', 'Tab'];
    if (
      !/^(?!\s)[A-Za-z\s'-]+$/.test(event.key) &&
      !allowedKeys.includes(event.key)
    ) {
      event.preventDefault();
    }
  }
  ////checkbox validation
  // atLeastOneCheckboxCheckedValidator(control: AbstractControl): ValidationErrors | null {
  // const controls = control.value;
  // console.log(this.allDepartment)
  // const checkboxFields =  this.allDepartmentCd
  // const atLeastOneChecked = checkboxFields && checkboxFields.some((field:any) => {
  //   const fieldControl = control.get(field);
  //   return fieldControl && fieldControl.value === true;
  // });

  // return atLeastOneChecked ? null : { atLeastOneRequired: true };
  // }

  //mobile number validation
  indianMobileValidator(control: AbstractControl): ValidationErrors | null {
    const value = control.value;
    const pattern = /^[6-9][0-9]{9}$/;
    return pattern.test(value) ? null : { invalidMobile: true };
  }
  allowOnlyKeysForMobile(event: KeyboardEvent): void {
    const allowedKeys = ['Backspace', 'ArrowLeft', 'ArrowRight', 'Tab'];
    if (
      !/^(?!\s)[0-9]+$/.test(event.key) &&
      !allowedKeys.includes(event.key)
    ) {
      event.preventDefault();
    }
  }

  //// description validation//////////

  noStartWithWhitespaceValidator(control: AbstractControl): ValidationErrors | null {
    const value = control.value;
    if (typeof value === 'string' && value.length > 0 && /^\s/.test(value)) {
      return { leadingWhitespace: true };
    }
    return null;
  }
  // Hilight field if reruired field is not field

  markFieldsAsTouched() {
    Object.values(this.complaint_form.controls).forEach(control => {
      control.markAsTouched();
    });
  }

  openSuccessModalWithoutCheck(complaintId: string) {
    this.dialog.open(SuccessModalWithoutCheckComponent, {
      width: '600px',
      height: 'auto',
      data: { complaintId: complaintId }  // 👈 pass it here
    });
  }


  openResolvedSuccessModal() {
    this.dialog.open(SuccessModalWithCheckComponent, {
      width: '600px'
    });
  }




  async onSubmit() {
    let flag = false
    console.log(this.complaint_form)
    console.log(this.intant_resolve_form)
    if (!this.complaint_form.valid) {
      flag = true
      this.markFieldsAsTouched();
    }

    if (this.is_instant_resolved && !this.intant_resolve_form.valid) {
      flag = true
    }


    if (flag) {
      swal.fire("Error...", "Please fill all required fields.", "error");
      return
    }

    let dept: any = []
    this.allDepartmentCd.map((x: any) => {
      if (this.complaint_form.value[Object.keys(x).join("")]) {
        dept.push(x)
      }
    })

    if (dept.length < 1) {
      swal.fire("Error...", "Mark at least one Department", 'info');
      return
    }

    if (this.resolverArr.length < 1) {
      swal.fire("Error...", "Not any Officer map in this  Derpartment or zone ", 'info');
      return
    }





    let obj = { ...this.complaint_form.value, ...this.intant_resolve_form.value };
    obj['dept'] = dept
    obj['b_acct_id'] = this.erpUser.b_acct_id;
    obj['create_user_id'] = this.erpUser.le_id;
    obj['is_instant_resolved'] = this.is_instant_resolved
    obj['escalated_time'] = this.allEscalationRule[0] && this.allEscalationRule[0]['time'] || 7;
    obj['create_role_cd'] = this.erpUser.role_cd.join(",")
    obj['create_user_name'] = this.erpUser.role_cd.join(",")
    obj['resolver_user_name'] = this.resolverObj[obj['resolver_user_id']]['party_name']
    obj['resolver_role_cd'] = this.resolverObj[obj['resolver_user_id']]['role_cd']
    let data = new FormData();
    let doc = []
    if (this.selectedFileUrlObj['com'] && this.selectedFileUrlObj['com']['file_name']) {
      data.append('file', this.selectedFileUrlObj['com']['event']);
      doc.push({ doc_type: 'com', doc_name: this.selectedFileUrlObj['com']['file_name'] })
      obj['com_doc'] = this.selectedFileUrlObj['com']['file_name']
    }

    if (this.selectedFileUrlObj['others'] && this.selectedFileUrlObj['others']['file_name']) {
      data.append('file', this.selectedFileUrlObj['others']['event']);
      doc.push({ doc_type: 'others', doc_name: this.selectedFileUrlObj['others']['file_name'] })
      obj['others_doc'] = this.selectedFileUrlObj['others']['file_name']
    }

    if (this.selectedFileUrlObj['resolved'] && this.selectedFileUrlObj['resolved']['file_name']) {
      data.append('file', this.selectedFileUrlObj['resolved']['event']);
      doc.push({ doc_type: 'resolved', doc_name: this.selectedFileUrlObj['resolved']['file_name'] })
      obj['resolved_doc'] = this.selectedFileUrlObj['resolved']['file_name']
    }
    obj['doc'] = doc
    console.log(obj)
    data.append('data', JSON.stringify(obj));
    this.tspinner.show('', '')
    let resp = await this.cs.complauints(data)
    if (resp['error'] == false) {
      this.tspinner.hide()
      if (this.is_instant_resolved) {
        await this.openResolvedSuccessModal();
      } else {
        await this.openSuccessModalWithoutCheck(resp['id']);
      }
      this.tspinner.hide()
      this.complaint_form.reset();
      this.intant_resolve_form.reset();
      this.formSubmitted = false;
      this.is_instant_resolved = false;
      this.selectedFileUrlObj = {};
      this.uploaded_fileName = '';
      this.wordArr = [];
      this.mohallaArr = [];
      this.resolverArr = [];
      this.selectedZone = null;

      if (this.comDocInput) this.comDocInput.nativeElement.value = '';
      if (this.othersDocInput) this.othersDocInput.nativeElement.value = '';
      if (this.resolvedDocInput) this.resolvedDocInput.nativeElement.value = '';
      return

    }
    swal.fire('Opps !!', resp['data'], 'info')
    return




    //   else if (this.complaint_form.valid && !this.is_instant_resolved) {

    //     this.openSuccessModalWithoutCheck();
    //   }



    //   else if (this.complaint_form.valid && this.is_instant_resolved) {
    //     if (!this.intant_resolve_form.valid) {
    //       swal.fire("Error...", "Please fill all required fields correctly.", "error");
    //       return;
    //     } else {
    //       this.openResolvedSuccessModal();
    //     }
    //   }
    //   else {
    //     swal.fire("Error...", "Please fill all required fields correctly.", "error");
    //   }
  }




  /*-------------file setup------------------*/

  // selected_authority: any = {}
  // async openUpload(element) {
  //   this.selected_authority = element
  //   let file: any = document.getElementById('mapFileInput')
  //   console.log(file)
  //   if (file.value) {
  //     file.value = ''
  //   }
  //   if (this.selectedFileUrl) {
  //     URL.revokeObjectURL(this.selectedFileUrl);
  //   }
  //   this.selectedFileUrl = null
  //   this.obj.event = undefined
  //   this.obj.file_name = undefined
  //   $('#condtion').modal('show');
  // }




  obj: any = {}
  selectedFileUrlObj: any = {}
  async checkFile(event: any, doc: any) {
    this.tspinner.show('', '')
    let resp: boolean = await this.fus.validatePdfSize(event);

    if (this.selectedFileUrlObj[doc] && this.selectedFileUrlObj[doc]['url']) {
      URL.revokeObjectURL(this.selectedFileUrlObj[doc]);
    }
    this.selectedFileUrlObj[doc] = {}

    if (!resp) {
      this.tspinner.hide()
      this.selectedFileUrlObj[doc] = {}
      switch (doc) {
        case 'com':
          this.comDocInput.nativeElement.value = '';
          break;
        case 'others':
          this.othersDocInput.nativeElement.value = '';
          break;
        case 'resolved':
          this.resolvedDocInput.nativeElement.value = '';
          break;

        default:
          console.log("switch");
          break;
      }
      this.selectedFileUrlObj[doc]['url'] = undefined
      this.selectedFileUrlObj[doc].event = undefined;
      this.selectedFileUrlObj[doc].file_name = undefined;
    }

    this.tspinner.hide()
    const file: File = event.target.files[0];
    this.selectedFileUrlObj[doc]['url'] = URL.createObjectURL(file);
    this.selectedFileUrlObj[doc].event = event.target.files[0]
    this.selectedFileUrlObj[doc].file_name = event.target.files[0]['name'];

  }




  async view(doc: string) {
    if (this.selectedFileUrlObj[doc]['url']) {
      window.open(this.selectedFileUrlObj[doc]['url'], '_blank');
    }
  }


  imgURL: any
  async viewDoc(obj: any) {
    if (obj["file_name"] != undefined) {
      this.tspinner.show('', '')
      const res = await this.cs.viewDoc(obj);
      if (res) {
        var docname = obj["file_name"];
        var ext = docname.split(".");
        if (
          ext[1] == "png" ||
          ext[1] == "jpeg" ||
          ext[1] == "jpg" ||
          ext[1] == "PNG" ||
          ext[1] == "JPEG" ||
          ext[1] == "JPG"
        ) {
          let file = new Blob([res], { type: "image/png" });
          var fileURL = window.URL.createObjectURL(file);
          this.imgURL = this.sanitizer.bypassSecurityTrustUrl(fileURL);
          this.tspinner.hide();
          window.open(fileURL, "_blank");
        } else if (ext[1].toLowerCase() == "xlsx") {
          let file = new Blob([res], {
            type: "application/vnd.openxmlformats-officedocument.spreadsheetml.sheet",
          });
          var fileURL = URL.createObjectURL(file);
          window.open(fileURL);
          this.tspinner.hide();
        } else if (
          ext[1].toLowerCase() == "docx" ||
          ext[1].toLowerCase() == "doc"
        ) {
          let file = new Blob([res], {
            type: "application/vnd.openxmlformats-officedocument.wordprocessingml.document",
          });
          var fileURL = URL.createObjectURL(file);
          window.open(fileURL);
          this.tspinner.hide();
        } else {
          let file = new Blob([res], { type: "application/pdf" });
          var fileURL = URL.createObjectURL(file);
          window.open(fileURL);
          this.tspinner.hide();
        }
      } else {
        this.tspinner.hide();
      }
    } else {
      this.tspinner.hide();
      swal.fire("Error", "No document Uploaded !", "error");
    }
  }

  resolverArr: any = []
  resolverObj: any = {}
  node_cd :any = []
  async getResolver() {

    let dept: any = []
    this.allDepartmentCd.map((x: any) => {
      if (this.complaint_form.value[Object.keys(x).join("")]) {
        dept.push(Object.keys(x).join(""))
      }
    })

    // let zone_cd = this.complaint_form.value['zone_leaf_cd']

    if (!(dept.length > 0 && this.node_cd.length > 0)) {
      return
    }

    let obj = { b_acct_id: this.erpUser.b_acct_id, zone_cd: this.node_cd, dep_cd: dept, role_cd: 'Officer' }
    let resp = await this.cs.getResolver(JSON.stringify(obj));
    if (resp['error'] == false) {
      this.resolverArr = resp['data']
      this.resolverArr.map((x: any) => {
        this.resolverObj[x['user_id']] = x
      })
      return
    } else {
      swal.fire('Opps !!', resp['data'], 'error')
      return
    }




  }


  back() {
    this.location.back()
  }

}
